<div class="container sms011">
  <!-- ヘッダーエリア -->
  <app-header></app-header>
  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area sms011-content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">

        <div>
          <fieldset class="grid-frame">
            <br>
            <div>
              <mat-label class="message-error">{{lblMessage01}}</mat-label>
            </div>
            <br>
            <br>
            <div>
              <mat-label class="message">{{lblMessage02}}</mat-label>
            </div>
            <br>
            <div>
              <mat-label class="message">{{lblMessage03}}<a href="{{lblTel01}}">{{lblTel02}}</a></mat-label>
            </div>
          </fieldset>
        </div>
        <br><br>

      </form>
    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button [style.visibility]="btnMenuVisibility" class="back-button" (click)="backClick()" accesskey="q" tabindex="2">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
